import {
  MINIMAL_HEADER_HEIGHT_LG,
  MINIMAL_HEADER_HEIGHT_XS,
} from '@/styles/theme/constants';
import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'GlobalMinimalHeader',
})(({ brandColors, spacing, breakpoints, type, typography }, props) => ({
  logo: {
    margin: `0 ${typography.pxToRem(15)}`,
  },
  container: {
    padding: `${spacing(1)} 0`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
    [breakpoints.up('lg')]: {
      minHeight: typography.pxToRem(MINIMAL_HEADER_HEIGHT_LG),
    },
    minHeight: typography.pxToRem(MINIMAL_HEADER_HEIGHT_XS),
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoContainer: {
    color: darkOrLightStyle(props)(
      brandColors.tintsChargeBlue60,
      brandColors.mediumBlue
    ),
    ...type['14_regular'],
    [breakpoints.up('sm')]: {
      marginBottom: 'auto',
    },
  },
  phoneContainer: {
    color: darkOrLightStyle(props)(
      brandColors.tintsChargeBlue60,
      brandColors.mediumBlue
    ),
    ...type['14_medium'],
    width: '100%',
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  number: {
    marginLeft: spacing(-1),
    marginRight: spacing(-1),
    '&:hover': {
      color: darkOrLightStyle(props)(
        brandColors.white,
        brandColors.primaryMain
      ),
    },
  },
  cartAndPhone: {
    display: 'flex',
    gap: typography.pxToRem(8),
  },
}));

export default useStyles;
